import {
  toaster,
  type ToastOptions
} from "@pathwright/ux/src/components/chakra/ui/toaster"
import { useEffect } from "react"
import { useCopyToClipboard as _useCopyToClipboard } from "react-use"

export type UseCopyToClipboardReturn = ReturnType<typeof useCopyToClipboard>

const useCopyToClipboard = (value?: string, options?: ToastOptions) => {
  const [_, onCopy] = _useCopyToClipboard()

  const handleToast = (value: string, _options?: ToastOptions) => {
    toaster.create({
      title: "Copied to clipboard",
      description: <span style={{ overflowWrap: "anywhere" }}>{value}</span>,
      type: "success",
      duration: 2000,
      closable: false,
      ...options,
      ..._options
    })
  }

  // Toasts and copies the value.
  const handleCopy = (value: string, options?: ToastOptions) => {
    onCopy(value)
    handleToast(value, options)
  }

  // Optionally copy via effect when value changes.
  useEffect(() => {
    if (value) {
      handleCopy(value)
    }
  }, [value])

  // Alternately copy on demand.
  return handleCopy
}

export default useCopyToClipboard
